import { Controller } from 'react-hook-form';
import { ComboboxItem, Select } from '@mantine/core';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';
import React from 'react';

type NumberSelectOption = {
	value: number;
	label: string;
	disabled?: boolean;
};

interface Props {
	name: string;
	data: NumberSelectOption[];
	disabled?: boolean;
	placeholder?: string;
	selectItemComponent?: React.FC<ComboboxItem>;
}

export function NumberSelect({ name, data, selectItemComponent, ...rest }: Props) {
	const options = data.map((item) => ({
		value: item.value.toString(),
		label: item.label,
		disabled: item.disabled,
	}));

	return (
		<Controller
			name={name}
			render={({ field }) => (
				<Select
					{...rest}
					data={options}
					value={field.value != null ? String(field.value) : null}
					onChange={(val) => field.onChange(val != null ? Number(val) : null)}
					onBlur={field.onBlur}
					ref={field.ref}
					size="md"
					renderOption={
						selectItemComponent
							? ({ option }) => React.createElement(selectItemComponent, option)
							: undefined
					}
					rightSection={<Icon variant="caret-down" size="lg" />}
					rightSectionProps={{ style: { pointerEvents: 'none' } }}
				/>
			)}
		/>
	);
}
